module.exports = __webpack_public_path__ + "static/media/MCII_quadro.4509337d.png";